
let index: number = 0;

const MovementItemsModalGridPluginSettings: IPluginSettings = {
    name: 'Перемещение товара из заявки',
    mnemocode: 'movement_items_modal_plugin',
    permission: 'MovementItemsModal',
    columns: [
        {
            order: index++,
            propertyName: 'goodsName',
            propertyType: 'string',
            displayName: 'Наименование товара',
            visibility: true,
            width: 100
        }, {
            order: index++,
            propertyName: 'actualQuantity',
            propertyType: 'number',
            displayName: 'Остаток',
            visibility: true,
            width: 100,
        }, {
            order: index++,
            propertyName: 'quantity',
            propertyType: 'number',
            displayName: 'Количество',
            visibility: true,
            width: 100,
            changeable: true
        },{
            order: index++,
            propertyName: 'scalingRatioName',
            propertyType: 'string',
            displayName: 'Единица измерения',
            visibility: true,
            width: 100,
        },{
            order: index++,
            propertyName: 'mnn',
            propertyType: 'string',
            displayName: 'МНН',
            visibility: true,
            width: 100
        },{
            order:  index++,
            propertyName: 'tradeName',
            propertyType: 'string',
            displayName: 'ТН',
            visibility: true,
            width: 150
        },{
            order: index++,
            propertyName: "cureFormName",
            propertyType: "string",
            displayName: "Лек. форма",
            visibility: true,
            width: 150,
        },{
            order: index++,
            propertyName: "dosage",
            propertyType: "string",
            displayName: "Дозировка",
            visibility: true,
            width: 150,
        },{
            order: index++,
            propertyName: "nFv",
            propertyType: "number",
            displayName: "Фасовка",
            visibility: true,
            width: 150,
        },
    ]
}
export default MovementItemsModalGridPluginSettings